import { SectionLabel, Reveal } from '../Section';

const STEPS = [
  { title: 'Download the App', desc: 'Grab KROY Esports from Google Play or the App Store — free, fast and lightweight.' },
  { title: 'Create Your Account', desc: 'Sign up in under a minute with your mobile number and set your game IGN.' },
  { title: 'Join a Tournament', desc: 'Open the Arena, pick a BGMI or Free Fire tournament and lock your slot.' },
  { title: 'Play & Compete', desc: 'Get the room ID in-app, join the lobby and fight your way up the leaderboard.' },
  { title: 'Withdraw Your Winnings', desc: 'Prizes land in your Winning Vault automatically — cash out straight to UPI.' },
];

export default function HowItWorks() {
  return (
    <section className="py-20 sm:py-28" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionLabel testid="how-it-works-label">How It Works</SectionLabel>
        <Reveal>
          <h2 className="mt-5 font-display text-white text-3xl sm:text-5xl">
            Five steps to your <span className="text-[#e8173a]">first win</span>
          </h2>
        </Reveal>
        <div className="mt-14 space-y-0">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06}>
              <div
                data-testid={`how-step-${i + 1}`}
                className="group flex items-start gap-6 sm:gap-10 py-8 border-t border-white/5 last:border-b hover:bg-[#1a1f2e]/40 transition-colors duration-300 px-4 sm:px-6 -mx-4 sm:-mx-6 rounded-lg"
              >
                <span className="font-display text-5xl sm:text-7xl text-stroke-red group-hover:text-[#e8173a] group-hover:[-webkit-text-stroke:0px] transition-all duration-500 leading-none shrink-0 w-16 sm:w-24">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div className="pt-1 sm:pt-3">
                  <h3 className="text-white font-bold text-lg sm:text-xl">{s.title}</h3>
                  <p className="mt-1.5 text-sm text-[#9e9e9e] leading-relaxed max-w-xl">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
